// extracted by mini-css-extract-plugin
export default {"label":"price-list-select-module__label___wLVLT"};